import { useFieldArray, useFormContext } from 'react-hook-form';
import { Box, HStack, VStack } from 'native-base';

import { Text } from '@pimm/base';
import { useAppLocale } from '@pimm/common';
import { FormEquipmentProfile } from '../hooks/form-equipment-profile.hook';
import { EquipmentProfileItemRow } from './equipment-profile-item-row';

type EquipmentProfileCategoryCardProps = {
  fieldPath: `categories.${number}`;
  isDisabled?: boolean;
};

export const EquipmentProfileCategoryCard = ({ fieldPath, isDisabled }: EquipmentProfileCategoryCardProps) => {
  const { translate } = useAppLocale();
  const { control, getValues } = useFormContext<FormEquipmentProfile>();
  const { fields: items } = useFieldArray({ control, name: `${fieldPath}.items` });

  const category = getValues(fieldPath);

  return (
    <VStack shadow={1} borderRadius="lg">
      {/* Category header */}
      <HStack roundedTop="lg" alignItems="center" px={4} py={2} minH="50px" borderWidth={1} bg="white">
        <VStack space={0.5} flex={1}>
          <Text size="lg" fontWeight={600} color="gray.900" lineHeight="xs">
            {translate(category?.title, category?.titleTranslations)}
          </Text>

          {!!category?.subTitle && (
            <Text size="sm" color="gray.600">
              {translate(category?.subTitle, category?.subTitleTranslations)}
            </Text>
          )}
        </VStack>
      </HStack>

      {/* Items list */}
      <Box borderRadius="lg" borderTopRadius={0} borderWidth={1} borderTopWidth={0} borderColor="gray.200" overflow="hidden">
        {items.map((item, index) => (
          <HStack key={item.id} alignItems="stretch" borderTopWidth={index ? 1 : 0} borderColor="gray.100" bg="white">
            <EquipmentProfileItemRow fieldPath={`${fieldPath}.items.${index}`} isDisabled={isDisabled} />
          </HStack>
        ))}
      </Box>
    </VStack>
  );
};
